import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  // API keys for dev and live environments
  const devAPI = '3H8Lx8Dde8aXtOOqNOANh173MJ5U2XpT61Grmj2c';
  const liveAPI = 'qmoK9VfVbE9zB7uG5k4oS7a972ah5nvV9UJB7jt2';
  const apiKey = environment.production ? liveAPI : devAPI;

  return from(authService.getIDToken()).pipe(
    switchMap((token) => {
      const headers: Record<string, string> = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
      };

      if (token) {
        headers['Authorization'] = token.toString();
      }

      const reqClone = request.clone({ setHeaders: headers });
      return next(reqClone);
    })
  );
};
